<app-base-popup #basePopup (closed)="closed.emit()">
    <div class="ufp_contents padding16">
        <div class="ufp_header">{{lang.get('users.labels.searchUser')}}</div>
        <app-text-edit class="ufp_edit" (valueChanged)="userToFind = $event" (enterClicked)="confirmSearch()" #phraseEdit></app-text-edit>
        <div class="ufp_description">{{lang.get('users.labels.searchPhrase')}}</div>
        <div class="button ufp_button" (click)="confirmSearch()">{{lang.get('users.buttons.search')}}</div>
    </div>
</app-base-popup>